var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChartGhostLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "684px",
    height: "320px",
    viewBox: "0 0 684 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bar-chart-ghost-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart-ghost-light",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.049999997
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars",
    transform: "translate(2.000000, 85.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644,65.2560554 L644,235 L612,235 L612,65.2560554 L644,65.2560554 Z M68,125.121107 L68,235 L36,235 L36,125.121107 L68,125.121107 Z M32,98.5986159 L32,235 L0,235 L0,98.5986159 L32,98.5986159 Z M104,146.3391 L104,235 L72,235 L72,146.3391 L104,146.3391 Z M140,141.792388 L140,235 L108,235 L108,141.792388 L140,141.792388 Z M176,132.698962 L176,235 L144,235 L144,132.698962 L176,132.698962 Z M248,146.3391 L248,235 L216,235 L216,146.3391 L248,146.3391 Z M284,111.480969 L284,235 L252,235 L252,111.480969 L284,111.480969 Z M320,88.7474048 L320,235 L288,235 L288,88.7474048 L320,88.7474048 Z M356,75.8650519 L356,235 L324,235 L324,75.8650519 L356,75.8650519 Z M392,50.8581315 L392,235 L360,235 L360,50.8581315 L392,50.8581315 Z M428,0 L428,235 L396,235 L396,0 L428,0 Z M464,31.1557093 L464,235 L432,235 L432,31.1557093 L464,31.1557093 Z M500,16 L500,235 L468,235 L468,16 L500,16 Z M536,31.1557093 L536,235 L504,235 L504,31.1557093 L536,31.1557093 Z M572,50.8581315 L572,235 L540,235 L540,50.8581315 L572,50.8581315 Z M608,78.1384083 L608,235 L576,235 L576,78.1384083 L608,78.1384083 Z M680,50.8581315 L680,235 L648,235 L648,50.8581315 L680,50.8581315 Z M212,153.916955 L212,235 L180,235 L180,153.916955 L212,153.916955 Z",
    id: "Rectangle-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartGhostLight);
export default __webpack_public_path__ + "static/media/bar-chart-ghost-light.ca333cbb7d905b30bde6393cbb9f6781.svg";
export { ForwardRef as ReactComponent };